import { render, staticRenderFns } from "./SvMenu.vue?vue&type=template&id=217e7d60&scoped=true&lang=pug&"
import script from "./SvMenu.vue?vue&type=script&lang=js&"
export * from "./SvMenu.vue?vue&type=script&lang=js&"
import style0 from "./SvMenu.vue?vue&type=style&index=0&id=217e7d60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217e7d60",
  null
  
)

export default component.exports